import { observer } from "mobx-react-lite";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { TrackedEvent, TrackedEventContext, trackEvent } from "@/domains/metrics";
import { EmptyContainer, EmptyText, EmptyTextContainer } from "@/components/styling/empty";
import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import EmptyNotesImage from "@/assets/images/empty-notes.svg?react";
import EmptySharingImage from "@/assets/images/empty-sharing-notes.svg?react";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { LensKind } from "@/modules/lenses/types";
import {
  MDSButton,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
} from "@/mds";
import { useImportModal } from "@/contexts/ImportModalContext";
import styled from "@emotion/styled";

export const NotesListPageListEmpty = observer(function NotesListPageListEmpty() {
  const page = useTabPageStore("notesListPage");
  const { setIsImportModalOpen } = useImportModal();

  useEffectOnMount(() => {
    trackEvent(TrackedEvent.ImportCtaView, {
      context: TrackedEventContext.Notes,
    });
  });

  if (page.filters.hasAnyFilters) {
    return (
      <EmptyContainer>
        <EmptySearchImage />
        <EmptyText>No results match your selected filters</EmptyText>
        <MDSButton onClick={() => page.filters.clearAllFilters()}>Clear filters</MDSButton>
      </EmptyContainer>
    );
  }

  if (page.filters.params.lens === LensKind.SharedWithMe) {
    return (
      <EmptyContainer>
        <EmptySharingImage />
        <EmptyText>Notes shared with you appear here</EmptyText>
      </EmptyContainer>
    );
  }

  return (
    <EmptyContainer dataTestId="import-dropzone-ui">
      <EmptyNotesImage />
      <EmptyTextContainer>
        <StyledEmptyText>
          Notes that you and Mem Agent create will appear here.
          <br />
          Drag and drop notes here to import some.
        </StyledEmptyText>
        <StyledImportButtonContainer>
          <MDSButton
            variant={MDSButtonVariant.Contrast}
            aria-label="Import"
            onClick={() => {
              setIsImportModalOpen(true);
            }}
          >
            <MDSIcon
              aria-label="Arrow Up"
              slot={MDSButtonSlotName.LeftIcon}
              kind={MDSIconKind.Import}
              color={MDSIconColor.OnAccent}
              size={14}
            />
            Import notes
          </MDSButton>
        </StyledImportButtonContainer>
      </EmptyTextContainer>
    </EmptyContainer>
  );
});

const StyledEmptyText = styled(EmptyText)`
  line-height: 22px;
`;

const StyledImportButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing[2]};
`;
